import { render, staticRenderFns } from "./CombinedPredictTable.vue?vue&type=template&id=4eb44f3d&scoped=true"
import script from "./CombinedPredictTable.vue?vue&type=script&lang=js"
export * from "./CombinedPredictTable.vue?vue&type=script&lang=js"
import style0 from "./CombinedPredictTable.vue?vue&type=style&index=0&id=4eb44f3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb44f3d",
  null
  
)

export default component.exports